import Vue from "vue";
import Vuex from "vuex";
import * as moment from "moment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    dominio: null,
    unidade: null,
    unidades: null, 
    isMenuVisible: false,
    breadcrumb: [],
    loading: false,
    referencia: moment().format("YYYY-MM-DD"),
    referencia_fim: moment().format("YYYY-MM-DD"),
    contexto: {},
    options: {},
    relatorios_linkados: {}, 
    online: true,
    logo: "", 
    conectados: 0, 
  },
  mutations: {
    setOnline(state, online) { 
      if ( state.online != online ) { 
        window.app.$toast.add({
          severity: online ? 'success' : 'error',
          summary: "Atenção",
          detail: online ? 'Estamos Online!' : 'Estamos Offline',
          life: 5000
        });
      }
      state.online = online;
    },
    setDominio(state, dominio) {
      state.dominio = dominio;
    },
    setLogo(state, logo) {
      state.logo = logo;
    },
    setOptions(state, options) {
      state.options[options.name] = options.list;
    },
    setConectados(state, qtde) { 
      state.conectados = qtde;
    },
    zerarOptions(state) {
      state.options = [];
    },
    deleteOptions(state, id) {
      delete state.options[id];
    },
    setContexto(state, contexto) {
      if (contexto) {
        Object.keys(contexto).forEach(function(key) {
          state.contexto[key] = contexto[key];
        });
      }
    },
    setUnidade(state, unidade) {
      if ( unidade ) { 
        Vue.axios.defaults.headers.post["X-UNIDADE"] = unidade.id_unidade;
        Vue.axios.defaults.headers.get["X-UNIDADE"] = unidade.id_unidade;
      }
      
      state.unidade = unidade;
    },
    setUnidades(state, unidades) {
      state.unidades = unidades;
    },
    setRelatorioLinkado(state, novo) {
      state.relatorios_linkados = { 
        ...state.relatorios_linkados,
        ...novo
      };
    },
    setUser(state, user) {
      state.user = user;
      if (user) {
        state.isMenuVisible = true;
      } else {
        state.isMenuVisible = false;
      }
    },
    toggleMenu(state, isVisible) {
      if (!state.user) {
        state.isMenuVisible = false;
        return;
      }
      if (isVisible === undefined) {
        state.isMenuVisible = !state.isMenuVisible;
      } else {
        state.isMenuVisible = isVisible;
      }
    },
    setBreadcrumb(state, breadcrumb) {
      state.breadcrumb = breadcrumb;
    },
    loading(state, loading) {
      state.loading = loading;
    },
    setReferencia(state, value) {
      state.referencia = value;
    },
    setReferenciaFim(state, value) {
      state.referencia_fim = value;
    }
  },
  actions: {
    setUser(state, User) {
      state.commit("setUser", User);
    },
    setUnidade(state, Unidade) {
      state.commit("setUnidade", Unidade);
    }
  }
});
